import { useEffect, useState } from "react";

// Reactive online/offline indicator so the kiosk can show a friendly banner
// when the classroom internet drops. Also polls once on mount so the very
// first render is accurate even if the browser hasn't fired an event yet.
export default function useOnlineStatus() {
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true
  );

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    // Sync once in case the state changed between initial render and mount
    setOnline(navigator.onLine);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, []);

  return online;
}
